export interface ApplicationPropsId {
  applicantId: string;
}

export interface ApplicantDetails {
  _id: string;
  job: string;
  job_info: {
    application_deadline: string;
    contract_duration: string;
    department: string;
    employment_type: string;
    job_title: string;
    job_type: string;
    facility_info: {
      name: string;
    };
    work_type: string;
  };
  facility: string;
  facility_info: {
    name: string;
  };
  medic: string;
  medic_info: {
    full_name: string;
    name: string;
    specialities: string;
    state: string;

    years_of_experience: string[];
  };
  documents_url: string[];
  status: string;
  notes: string;
  created_at: string;
  updated_at: string;
}

export const ApplicantDetailsData = {
  _id: "",
  job: "",
  job_info: {
    application_deadline: "",
    contract_duration: "",
    job_description: "",
    status: "",
    work_location: "",
    job_title: "",
    job_type: "",
    department: "",
    employment_type: "",
    work_type: "",
  },

  facility: "",
  facility_info: {
    name: "",
  },

  medic: "",
  medic_info: {
    full_name: "",
    name: "",
    specialities: "",
    state: "",
    years_of_experience: [""],
  },
  documents_url: [""],
  status: "",
  notes: "",
  created_at: "",
  updated_at: "",
};

export interface CandidateDetailsProps {
  _id: string;
  job: string;
  job_info: {
    application_deadline: string;
    contract_duration: string;
    job_title: string;
    job_type: string;
    department: string;
    job_description: string;
    status: string;
    work_location: string;
    work_type: string;
    employment_type: string;
    facility_info: {
      name: string;
    };
  };
  facility: string;
  facility_info: {
    name: string;
  };
  medic: string;
  medic_info: {
    name: string;
    full_name: string;
    specialities: string;
    state: string;
    medic_type: string;
    years_of_experience: string[];
    gender: string;
    dob: string;
  };
  documents_url: string[];
  status: string;
  notes: string;
  created_at: string;
  updated_at: string;
  interview: {
    details: string;
    interview_date: string;
    location: string;
    setAt: string;
    type: string;
    link: string;
  };
}

export const CandidateDetailsData = {
  _id: "",
  job: "",
  job_info: {
    application_deadline: "",
    contract_duration: "",
    job_title: "",
    job_type: "",
    department: "",
    job_description: "",
    status: "",
    work_location: "",
    work_type: "",
    employment_type: "",
    facility_info: {
      name: "",
    },
  },
  facility: "",
  facility_info: {
    name: "",
  },
  medic: "",
  medic_info: {
    name: "",
    full_name: "",
    specialities: "",
    state: "",
    medic_type: "",
    years_of_experience: [""],
    gender: "",
    dob: "",
  },
  documents_url: [""],
  status: "",
  notes: "",
  created_at: "",
  updated_at: "",
};
